export const BACKUP_RETENTION_POLICY = "latest-four-v1";

export type BackupCipher = {
  format: "classroom-auto-backup";
  version: 1;
  workspaceId: string;
  objectId: string;
  iv: string;
  ciphertext: string;
};
export type BackupRecoveryPackage = {
  format: "classroom-backup-recovery";
  version: 1;
  accountId: string;
  workspaceId: string;
  keyId: string;
  salt: string;
  iterations: 600000;
  iv: string;
  ciphertext: string;
};
export type BackupCatalogEntry = { id: string; manifest: BackupCipher; verifiedAt: number };
export type BackupConfiguration = {
  workspaceId: string;
  keyId: string;
  recovery: BackupRecoveryPackage;
  recoveryPublicKey: JsonWebKey;
  recoveryFileId: string;
  enabled: boolean;
};
export type BackupControlState = {
  config: BackupConfiguration;
  devices: {
    id: string;
    signing: JsonWebKey;
    agreement: JsonWebKey;
    label: string;
    createdAt: number;
    revokedAt?: number;
  }[];
  challenges: { id: string; deviceId: string; signing: JsonWebKey; expiresAt: number }[];
  entries: BackupCatalogEntry[];
  returnPoint?: string;
  garbage?: string[];
  lease?: { id: string; deviceId: string; expiresAt: number; verified?: boolean };
  recoveryVerified: boolean;
};
